














import Vue, { PropType } from 'vue';
import { WarehouseStock } from '@/model/product-price-stock';

export default Vue.extend({
  name: 'WarehouseStockAvailable',
  props: {
    warehouseStock: {
      type: Object as PropType<WarehouseStock>,
      required: true
    },
    stockAvailabilityStatus: {
      type: String,
      required: true
    },
    delivery: Object,
    deliveryEstimate: {
      type: String,
      required: true
    },
    warehouseCountryFlag: {
      type: String,
      required: true
    }
  },
  computed: {
    iconClass(): string | null {
      if (this.stockAvailabilityStatus === 'available') {
        return 'icon-check-circle';
      } else if (this.stockAvailabilityStatus === 'sparse') {
        return 'icon-exclamation-circle';
      } else if (this.delivery) {
        return 'icon-clock-o';
      }
      return null;
    }
  }
});
